import { createFeature, StoreModule } from '@ngrx/store';
import { StoreKeys } from '../../models/store-keys';
import { workflowModelInfosReducer } from './reducer/workflow-model-infos-reducer';

export const workflowModelInfosStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.WORKFLOW_MODEL_INFOS,
    reducer : workflowModelInfosReducer
  })
);
